module.exports = __webpack_public_path__ + "img/footer_background.389e9e74.jpg";